import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const SchoolFee = () => {
    useEffect(() => {
        document.title = 'School Fee -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>School Fee </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> School Fee </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                      <div className="col-lg-12">
                         <p><strong>1.</strong> Fees must be deposited strictly according to the dates mentioned below:</p>
                            <ul className="list schoolfee">
                            <li><strong>July, August & September:</strong> 1st to 15th July</li>
                            <li><strong>October, November & December:</strong> 1st to 15th October </li>
                            <li><strong>January, February & March:</strong> 1st to 25th January </li>
                            </ul> 
                            <p><strong>2.</strong> A fine of Rs. 500/- will be charged per quarter in case of default. In no case should the dues be allowed to fall in arrears. If the fees fall in arrears the students name will be struck off from the School Rolls without further notice and re- admission may not be granted. If re - admission is granted full fees and formalities will be charged and processed as new admission. </p> 
                            <p><strong>3.</strong> No reduction or remission of fees may be claimed on account of holidays or absence from school due to any reason.  </p> 
                            <p><strong>4.</strong> School fee once paid will not be returned in any case. </p> 
                            <p><strong>5.</strong> Students, Whose dues are not cleared fully, will not be allowed to appear for the Examinations. </p> 
                            <p><strong>6.</strong> While applying for T.C. Fee Card Should be produced.</p> 
                            <p><strong>7.</strong> Fees are then quarterly. However, fees for the entire year or for the term may be paid.  </p> 
                            <p><strong>8.</strong> Any change made in the General Regulations of the school and in fees or any other change will be binding on parents/guardians/students.</p>
                                    
                      </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default SchoolFee